module.exports = __webpack_public_path__ + "ptc_nakagawa_I1.1c860ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_I1.jpg
// module id = KvHJ
// module chunks = 0